import { ReturnRequestLineItemDto } from "@babackapp/private-api-client/types";

type GetLineItemPaidPriceOptions = {
  lineItem: ReturnRequestLineItemDto;
  quantity?: number;
};

/**
 * This function will return the price paid by the custome
 * for a single element of a lineTtem.
 *
 * It also takes into account the taxes and discounts applied to the lineItem.
 *
 */
export function getLineItemPaidPrice({
  lineItem,
  quantity = 1,
}: GetLineItemPaidPriceOptions) {
  let price = parseFloat(lineItem.price);

  lineItem.unitTaxes.forEach((tax) => {
    if (!tax.includedInPrice) {
      price += tax.amount;
    }
  });

  lineItem.discountsAllocated.forEach((discount) => {
    if (discount.allocationMethod === "EACH") {
      price -= discount.amount / lineItem.quantity_bought;
    } else if (discount.allocationMethod == "ACROSS") {
      price -= discount.amount / lineItem.quantity_bought;
    }
  });

  price = Math.round((price + Number.EPSILON) * 100) / 100;

  return price * quantity;
}
